<template>
  <div class="health-check-intro">
    <div v-html="hcData.introduction"></div>
    <div class="health-check-intro__button-container">
      <button class="health-check-button" v-scroll-to="{ el: '#survey_intro' }">
        {{ hcData.button_text }}
      </button>
    </div>
    <div class="health-check-intro__statistics row">
      <div
        class="col-4 health-check-intro__statistics__item"
        v-for="(statistic, index) in hcData.statistics"
        v-bind:key="'stat' + index"
      >
        <div v-html="statistic.statistic"></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../store";

export default {
  store: store,
  methods: {
    scrollNext() {
      // scroll to the survey
      window.scrollTo({
        top:
          document.querySelector("#survey_intro").getBoundingClientRect().top -
          260,
        behavior: "smooth"
      });
    }
  },
  computed: {
    hcData() {
      return store.getters.hcData;
    }
  }
};
</script>
<style lang="scss">
.health-check-intro {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 66px;

  @media (max-width: 767px) {
    padding-top: 15px;
  }

  &__button-container {
    text-align: center;
    margin-top: 71px;

    @media (max-width: 767px) {
      margin-top: 38px;
    }
  }

  &__statistics {
    margin-top: 86px;

    @media (max-width: 767px) {
      margin-top: 48px;
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        display: flex;
        align-items: center;
        flex-direction: column;
      }

      &:first-child {
        justify-content: flex-start;
      }

      &:last-child {
        justify-content: flex-end;
      }

      p {
        text-align: center;
        color: #0000ff;
        font-size: 15px;
        font-weight: 300;
        line-height: 28px;
        letter-spacing: -0.38px;

        @media (max-width: 767px) {
          font-size: 12px;
          line-height: 18px;
        }

        strong {
          font-size: 26px;
          letter-spacing: -0.65px;

          @media (max-width: 767px) {
            font-size: 21px;
          }
        }
      }
    }
  }
}
</style>
